import { render, staticRenderFns } from "./NotifyMeModal.vue?vue&type=template&id=b6bc8bfc&scoped=true&"
import script from "./NotifyMeModal.vue?vue&type=script&lang=js&"
export * from "./NotifyMeModal.vue?vue&type=script&lang=js&"
import style0 from "./NotifyMeModal.vue?vue&type=style&index=0&id=b6bc8bfc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc8bfc",
  null
  
)

export default component.exports